module.exports = __webpack_public_path__ + "static/media/shutterstock_172135856_0021_022.c6d38cc1.png";